module.exports = __webpack_public_path__ + "static/img/banner03.2b1e6168.png";